export const mapPeople = (list, personType) =>
  list.map(({ person, role, id }) => ({
    label: `${person?.name} ${role?.title ? `(${role.title})` : ""}`,
    name: person?.name,
    value: id,
    roleLabel: role?.title,
    roleId: role?.id,
    avatarImg: person?.avatar,
    email: person?.email_address,
    phone: person?.phone_number,
    isCreated: false,
    personType,
  }));

export const mapRole = (roles, roleType) =>
  roles.map((role) => ({
    label: role?.title,
    value: role?.id,
    roleType,
  }));

export const generateRandomId = () => Math.floor(10000 + Math.random() * 90000);

export const truncateWord = (text, maxLength) => {
  return text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
};

export const mapToContactPayload = (arr) => {
  return arr.map((item) => ({
    first_name: item.firstName || "",
    last_name: item.lastName || "",
    email: item.email || "",
    phone_number: item.phone || "",
    role_id: item.roleId || null,
    add_to_transaction: item.addToTransaction || false,
  }));
};
